import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { TenantProvider } from './contexts/TenantContext';
import AppRoutesMessaging from './AppRoutes.messaging';
import './index.css';
import { AppearanceProvider } from './contexts/AppearanceContext';
import { i18nReady } from './i18n';

// Entry for messaging.chatbot.mn — operator live-messaging dashboard.
//
// Provider order: SocketProvider must wrap TenantProvider — TenantContext subscribes
// to `operator:access:changed` via `useSocketEvent`, which needs SocketContext above it.
// AuthProvider stays outermost; both downstream providers consume from it.

function MessagingShell() {
  const { token } = useAuth();
  return (
    <SocketProvider token={token}>
      <TenantProvider>
        <AppearanceProvider>
          <AppRoutesMessaging />
        </AppearanceProvider>
      </TenantProvider>
    </SocketProvider>
  );
}

// Render once the chosen language is loaded (it falls back to English on failure), so no English flashes first —
// but never wait more than 3 s: a stalled locale request must not leave a blank page.
void Promise.race([i18nReady, new Promise((resolve) => setTimeout(resolve, 3000))]).then(() =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <MessagingShell />
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>,
  ),
);
